// Abonelik paketleri.
//
// Paketler backend'den gelir:
//   POST /api/SubscriptionPlan/GetSubscriptionPlanList { targetType, category }
// Aşağıdaki FALLBACK_PLANS yalnızca API'ye ulaşılamazsa kullanılır.
//
// PARA BİRİMİ: Tüketiciye TL gösterilmesi zorunlu. Öncelik sırası:
//   1. API'den gelen `priceTry`  (tercih edilen — tahsil edilen tutarla birebir)
//   2. currency === 'TRY' ise `price`
//   3. Aksi hâlde `price` (USD) × USD_TRY_RATE  — yalnızca geçici çözüm
// 3. yola düşülüyorsa gösterilen tutar ile iyzico'nun çektiği tutar ayrışabilir.

export const USD_TRY_RATE = 46;

// API İngilizce plan adı → Türkçe UI adı
const PLAN_NAMES_TR = {
  Freemium: 'Başlangıç',
  Starter: 'Standart',
  Pro: 'Sınırsız',
};

const SYMBOLS = { TRY: '₺', USD: '$', EUR: '€' };

export const formatPrice = (price, currency = 'TRY') => {
  if (!price) return 'Ücretsiz';
  const amount = price.toLocaleString('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${amount} ${SYMBOLS[currency] || currency}`;
};

// API'den gelen planı UI'ın beklediği şekle çevirir
export function normalizePlan(raw) {
  // BE alan adını camelCase döndürüyor; PascalCase de kabul edilsin
  const priceTry = raw.priceTry ?? raw.PriceTry ?? null;
  const hasTry = priceTry !== null && priceTry !== undefined;

  const isFree = raw.planType === 'Free' || (hasTry ? !priceTry : !raw.price);

  let inTry;
  if (hasTry) inTry = priceTry;
  else if (raw.currency === 'TRY') inTry = raw.price;
  else inTry = (raw.price || 0) * USD_TRY_RATE;

  // API açıklaması zaten limiti anlatıyor; ayrıca kredi satırı eklemek tekrar olur
  const features = raw.description ? [raw.description] : [];

  return {
    id: raw.id,
    name: PLAN_NAMES_TR[raw.name] || raw.name,
    price: Number((inTry || 0).toFixed(2)),
    currency: 'TRY',
    // Fiyat TL olarak mı geldi, yoksa kurla mı çevrildi (teşhis için)
    priceConverted: !hasTry && raw.currency !== 'TRY',
    period: raw.planType === 'Monthly' ? 'ay' : null,
    summary: raw.description || '',
    features,
    isFree,
    isUnlimited: Boolean(raw.isUnlimited),
    creditCount: raw.creditCount,
    sortingId: raw.sortingId ?? 0,
  };
}

// API'ye ulaşılamazsa gösterilecek paketler (canlı verinin aynısı)
export const FALLBACK_PLANS = [
  {
    id: 'fallback-free',
    name: 'Freemium',
    description: 'Ayda 5 ilan başvurusu',
    planType: 'Free',
    price: 0,
    currency: 'USD',
    creditCount: 5,
    isUnlimited: false,
    sortingId: 1,
  },
  {
    id: 'fallback-starter',
    name: 'Starter',
    description: 'Ayda en fazla 50 ilan başvurusu',
    planType: 'Monthly',
    price: 3.99,
    currency: 'USD',
    creditCount: 50,
    isUnlimited: false,
    sortingId: 2,
  },
  {
    id: 'fallback-pro',
    name: 'Pro',
    description: 'Eşleşen tüm ilanlara otomatik başvuru',
    planType: 'Monthly',
    price: 10.99,
    currency: 'USD',
    creditCount: null,
    isUnlimited: true,
    sortingId: 3,
  },
].map(normalizePlan);

// Ortadaki paket öne çıkarılır
export const isPopular = (plan, all) =>
  all.length > 2 && plan.sortingId === 2;
